import React from "react";
import type { RulesDetails } from "../utils/authHelper";

export type RulesContextType = Partial<RulesDetails> | Record<string, any>;

const RulesDataContext = React.createContext<RulesContextType>({});

export default RulesDataContext;